module.exports = __webpack_public_path__ + "section-mask-bottom-large.2iK5iaeA.svg";